import React from "react";
import { Switch, Route } from "react-router-dom";

import Main from "../pages/Main";
import Contact from "../pages/Contact";

export default function Routes() {
  return (
    <Switch>
      <Route path="/sistema" exact component={Main} />
      <Route path="/contact" component={Contact} />
    </Switch>
  );
}
